// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608251934/js/" + chunkId + "." + {"44":"a9e6b1ac","225":"079aff51","481":"6454933a","486":"091d105d","770":"779fbed9"}[chunkId] + ".0.09240226729303291.chunk.js";
};